/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

// Component imports
import { Form, Input, Typography, Space, Checkbox } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

// Misc imports
import { useBotLanguage } from '../../../../utils/hooks/useBotLanguage';

// Constant declarations
const { Paragraph } = Typography;

const IntroNodeForm = ({ form }) => {
  const { t } = useTranslation();
  const { isEditingPrimaryLanguage } = useBotLanguage();

  return (
    <Fragment>
      {
        form.isFieldTouched('id') ? (
          <Paragraph type="danger">
            <ExclamationCircleOutlined className="mr-2" />
            {t('Editing the Intro node ID will affect any actions associated with this flow.')}
          </Paragraph>
        ) : null
      }

      <Form.Item
        label="ID"
        name={['id']}
        rules={[{ required: true, message: t('ID cannot be blank.') }]}
      >
        <Input
          size="large"
          placeholder={t('Enter a node ID')}
          disabled={!isEditingPrimaryLanguage}
        />
      </Form.Item>

      <Space>
        <Form.Item
          name={['data', 'resetSession']}
          valuePropName="checked"
          noStyle
        >
          <Checkbox disabled={!isEditingPrimaryLanguage} />
        </Form.Item>

        {t('Restart session')}
      </Space>
    </Fragment>
  );
};

IntroNodeForm.propTypes = {
  form: PropTypes.object.isRequired
};

export default IntroNodeForm;
